import { Prompt } from "react-router-dom";
import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { provideLocationState } from "components/utility/hoc/LocationState";

const OwlShopActions = require("lib/actions/OwlShopActions");
const OwlShopSelectors = require("lib/selectors/OwlShopSelectors");

var DisplayToggleControl = require("components/utility/DisplayToggleControl");
var CurrentUser = require("lib/account/CurrentUser");
var CoinDisplay = require("components/utility/CoinDisplay");
var LoadingButton = require("components/utility/LoadingButton");
var ReactTooltip = require("react-tooltip");
var Owlvatar = require("components/avatars/Owlvatar");
var StudentAvatar = require("components/avatars/StudentAvatar");
var OwlShopPatcher = require("components/avatars/OwlShopPatcher");

var OwlShopRouting = require("lib/routing/OwlShopRouting");

var Tiers = require("lib/games/Tiers");
var TierRequirementsDisplay = require("components/games/TierRequirementsDisplay");
var HouseModal = require("components/games/HouseModal");
var AnimationModal = require("components/games/AnimationModal");
var ShopSales = require("lib/games/ShopSales");
var OwlPhotosDisplay = require("components/avatars/OwlPhotosDisplay");



require("avatars/owl_shop_page.scss");

@provideLocationState(OwlShopRouting.getRouteState)
@connect(
	(state, ownProps) => ({
		filteredPatches: OwlShopSelectors.getFilteredPatches({ state }),
		filteredPerks: OwlShopSelectors.getFilteredPerks({ state }),
		allFurnitures:  OwlShopSelectors.getFurnitures({ state }),
		user: CurrentUser.get()
	}),
	(dispatch, props) => ({
		populateData: () =>
			Promise.all([
				dispatch(OwlShopActions.fetchPatches()),
				dispatch(OwlShopActions.fetchPerks()),
				dispatch(OwlShopActions.fetchFurnitures()),
			]),
		updateAvatar: ({ id, update, embeds, query }) =>
			dispatch(OwlShopActions.updateAvatar({ id, update, embeds, query })),
		updateCurrentUser: (callback) => CurrentUser.fetchCurrentUserData(callback),
		fetchPerks: ()=> dispatch(OwlShopActions.fetchPerks()),
		fetchPatches: ()=>dispatch(OwlShopActions.fetchPatches())
	}),
)

@providePopulateData()
class OwlShopPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var avatar = props.user.avatar;

		var startPatchType = this.hideOwls(props.user) ? null : "head";
		var startOtherType = this.hideOwls(props.user) ? "titles" : null;

		// parses url to get preview item from golden egg modal
		if($wr.getURLParameterByName("itemName") && $wr.getURLParameterByName("itemType")) {
			var itemName = $wr.getURLParameterByName("itemName")
			var itemType = $wr.getURLParameterByName("itemType")
			// preview patch
			if ($wr.getURLParameterByName("patch")) {
				startPatchType = itemType
				startOtherType = null
			// preview furniture
			} else if ($wr.getURLParameterByName("furniture")) {
				var furnitureName = itemName
				var furnitureType = itemType
			//preview perk
			} else {
				startOtherType = itemType
				startPatchType = null
			}
		}

		this.state = {
			equippedPatches: avatar.patches,
			colors: avatar.colors,
			previewFurnitureName: furnitureName? furnitureName : null,
			previewFurnitureType: furnitureType? furnitureType : null,
			previewItemName: itemName? itemName : null,
			previewItemType: itemType? itemType : null,
			loading: false,
			allFurnitures: [],
			activePatchType: startPatchType,
			activeOtherType: startOtherType,
			activeRoom: "trophy",
			beginAtTier: false
		};

	}
	setEquippedPatches(patches) {
		this.setState({ equippedPatches: patches });
	}
	setColors(colors) {
		this.setState({ colors: colors });
	}
	setPreviewItem(name, type) {
		this.setState({ previewItemName: name, previewItemType: type });
	}
	setActiveType(pType, oType) {
		this.setState({ activePatchType: pType, activeOtherType: oType });
	}
	requiresSave() {
		if (this.props.user == undefined) {
			return false;
		}
		var oldAvatar = this.props.user.avatar;
		var updated = false;

		_.each(this.state.equippedPatches, function(patch, patchType) {
			if (patch.name != oldAvatar.patches[patchType].name) {
				updated = true;
			}
		});

		_.each(
			oldAvatar.patches,
			function(patch, patchType) {
				if (
					this.state.equippedPatches[patchType] == undefined ||
					patch.name != this.state.equippedPatches[patchType].name
				) {
					updated = true;
				}
			}.bind(this),
		);

		_.each(this.state.colors, function(color, patchType) {
			if (color != oldAvatar.colors[patchType]) {
				updated = true;
			}
		});

		return updated;
	}

	getPreviewItem() {
		if (this.state.activePatchType) {
			return _.find(
				this.props.filteredPatches,
				function(patch) {
					return (
						patch.name == this.state.previewItemName &&
						patch.patch_type == this.state.activePatchType
					);
				}.bind(this),
			);
		} else {
			return _.find(
				this.props.filteredPerks,
				function(perk) {
					return (
						perk.name == this.state.previewItemName &&
						perk.perk_type == this.state.activeOtherType
					);
				}.bind(this),
			);
		}
	}

	previewAnimation(name) {
		this.setState({previewAnimationName: name})
		this.refs.animationModal.show();
	}

	notifyErrors = errors => window.wrNotifications.triggerDropDownNotification({
		title: "Sorry!",
		text: errors.join(", "),
		icon: "exclamation-sign",
		type: "error",
	});

	notifyAvatarSaved = () => window.wrNotifications.triggerDropDownNotification({
		title: "Great!",
		text: "Your Owlvatar has been saved!",
		icon: "ok-sign",
	});

	handleAvatarUpdated = avatar => {
		if(avatar.errors) this.notifyErrors(avatar.errors);
		else {
			this.notifyAvatarSaved();
			this.props.updateCurrentUser(
				()=>this.forceUpdate()
			);
			Mycroft.newEvent({ category: "Owl Shop", action: "save-avatar" });
		}
	}


	saveAvatar() {
		var avatarData = {
			patches: this.state.equippedPatches,
			colors: this.state.colors,
		};
		var avatarID = this.props.user.avatar.id;
		this.setState({ loading: true });

		this.props.updateAvatar({id: avatarID,update:{...avatarData}}).then(
			result=>{
				this.setState({loading:false});
				this.handleAvatarUpdated (result.avatar)
			}
		)
	}

	buildItemTypeSelectF(patchType, otherType) {
		return function(e) {
			$wr.nope(e);
			this.setState({
				activePatchType: patchType,
				activeOtherType: otherType,
				previewItemName: null,
				previewItemType: null,
			});

			Mycroft.newEvent({
				category: "Owl Shop",
				action: "select-category",
				label: patchType || otherType,
			});
		}.bind(this);
	}

	// to keep category selector highlighted correctly in hand and body special cases
	isActivePatchType(patchType) {
		var activePatchType = this.state.activePatchType;
		if (
			activePatchType == "left_hand" ||
			activePatchType == "hand" ||
			activePatchType == "wings"
		) {
			return patchType == "left_hand";
		} else if (activePatchType == "body" || activePatchType == "body2") {
			return patchType == "body";
		} else {
			return patchType == activePatchType;
		}
	}

	renderCategorySelector(text, patchType, otherType) {
		if (patchType) {
			var onClick = this.buildItemTypeSelectF(patchType, null);
		} else {
			var onClick = this.buildItemTypeSelectF(null, otherType);
		}
		if (this.state.activePatchType && this.isActivePatchType(patchType)) {
			var categoryClass = "selector selectedPatchType";
		} else {
			if (this.state.activeOtherType && this.state.activeOtherType == otherType) {
				var categoryClass = "selector selectedPatchType";
			} else {
				var categoryClass = "selector";
			}
		}

		return (
			<a href="#" className={categoryClass} onClick={onClick}>
				<img src={dynamicRequire("owl-item-types/" + (patchType || otherType) + ".png")} />
				<span className="categoryTitle">{text}</span>
			</a>
		);
	}

	hideOwls = (user) => user && user.settings && user.settings.hide_owls;

	renderOwlvatar() {
		if (this.hideOwls(this.props.user)) {
			return <StudentAvatar student={this.props.user} maxWidth={175} />;
		}
		var patches = {};
		var previewPatch = this.getPreviewItem();

		_.each(
			this.state.equippedPatches,
			function(patch, patchType) {
				if (
					previewPatch &&
					patchType == this.state.previewItemType &&
					previewPatch.tier <= this.props.user.tier + 1
				) {
					patches[patchType] = previewPatch;
				} else {
					patches[patchType] = patch;
				}
			}.bind(this),
		);

		return <Owlvatar patches={patches} colors={this.state.colors} maxWidth={280} />;
	}

	// gets the number of items needed to level up
	getRemainingReqsCount(patches, perks, furnitures){
		var tier = this.props.user.tier
		var reqs = Tiers.REQUIREMENTS[tier]  

		var remainingReqs = $wr.getRemainingReqs(tier, reqs, patches, perks, furnitures)

		var remaining = 0;
		for (var [objType, reqs] of Object.entries(remainingReqs)){
			remaining += reqs
		}
		return remaining
	}


	renderTierRequirements() {
		var tierColor = Tiers.getColor(this.props.user.tier);
		var currentTier = this.props.user.tier.toString();
		if (!this.hideOwls(this.props.user) && Tiers.isSupportedTier(currentTier)) {
			var tierReqs = Tiers.getRequirements(currentTier);
			var ownedPatches = _.select(this.props.filteredPatches, function(patch) {
				return patch.owned && patch.source == "store";
			});
			var ownedPerks = _.select(this.props.filteredPerks, function(perk) {
				return perk.owned && perk.source == "store";
			});
			var ownedFurnitures = _.select(this.props.allFurnitures, function(furniture) {
				return furniture.owned && furniture.source == "store";
			});

			var remainingReqsCount = this.getRemainingReqsCount(this.props.filteredPatches, this.props.filteredPerks, this.props.allFurnitures)

			// add explanations to the tier reqs display
			var reqsDescriptionTop = (
				<p className="reqsDescriptionTop">
					Buy {remainingReqsCount} more items to level up:
				</p>
			)
			var reqsDescriptionBottom = (
				<p className="reqsDescriptionBottom" style = {{color: tierColor}}>
					You can afford items in the highlighted categories!
				</p>
			)
			
			return (
				<div className="currentTierReqs">
					{reqsDescriptionTop}
					<TierRequirementsDisplay
						requirements={tierReqs}
						tier={currentTier}
						toggleRoom={this.toggleRoom.bind(this)}
						ownedPatches={ownedPatches}
						ownedPerks={ownedPerks}
						ownedFurnitures={ownedFurnitures}
						toggleCategory={this.toggleCategory.bind(this)}
						beginAtTier={this.beginAtTier}
						filteredPatches={this.props.filteredPatches}
						filteredPerks={this.props.filteredPerks}
						allFurnitures={this.props.allFurnitures}
						coins={this.props.user.coins}
					/>
					{reqsDescriptionBottom}
				</div>
			);
		}
	}

	//if true, skips to page with items at the user's tier
	beginAtTier(value, callback) {
		if (value) {
			this.setState({beginAtTier: value})
		}
	}

	// switches item type when a tier req square is clicked
	toggleCategory(category, type, callback) {
		if (category == "perk") {
			if (type == "houses"){
				this.setState({activePatchType: null, activeOtherType: "houses"})	
			} else {
				this.setState({activePatchType: null, activeOtherType: "titles"})	
			}
		} else if (category == "patch") {
			this.setState({activePatchType: type, activeOtherType: null})
		} else {
			this.setState({activePatchType: null, activeOtherType: "titles"})
			this.toggleRoom(type)
		}
	}

	toggleRoom(value, callback) {
		this.setState({ activeRoom: value }, this.openTrophyRoom);
	}

	openTrophyRoom() {
		this.refs.houseModal.show();
	}

	switchActiveView(view) {
		$wr.redirect(OwlShopRouting.getPath({
			...this.props.locationState,
			activeView: view
		}))
		//make sure background and owlshop/owlstagram toggle their styles
		//correctly when flipping between them.
		if (view == "shop"){
			$wr.displayBackground(this.props.user.perks.backgrounds)
			if ($wr.hasBackgroundEquipped(this.props.filteredPerks)){
				$(".displayToggleControl").addClass('withBackground')
			}
		}
		else {
			if ($wr.hasBackgroundEquipped(this.props.filteredPerks)){
				$(".displayToggleControl").removeClass('withBackground')
			}
		}
	}

	openHouse() {
		this.setState({activeRoom: "house"})
		this.openTrophyRoom()
	}


	render() {
		var shouldHideOwls = this.hideOwls(this.props.user);
		if (this.requiresSave()) {
			var saveButton = (
				<LoadingButton
					onClick={this.saveAvatar}
					loading={this.state.loading}
					className="btn buttonSuccess saveButton"
					text="Save"
				/>
			);
		}
		if (this.state.activeOtherType == TITLES && this.state.previewItemName) {
			var nameDisplay = this.state.previewItemName + " " + this.props.user.display_name;
		} else {
			var title = $wr.fetchTitle(this.props.user);
			if (title) {
				var nameDisplay = title;
			} else {
				var nameDisplay = this.props.user.display_name;
			}
		}

		// previews background
		if (this.state.activeOtherType == BACKGROUNDS && this.state.previewItemName) {
			$(".patcher").addClass("backgroundPatcher");
			$wr.displayBackground(this.state.previewItemName);
		}

		var headerText = shouldHideOwls ? "Shop" : "Owl Shop";
		var tierIconTooltipText = "Level " + (this.props.user.tier + 1) + ": " + Tiers.getName(this.props.user.tier);

		var toggleOptions = [
			{ key: OwlShopRouting.VIEWS.SHOP, text: "Shop" }, 
			{ key: OwlShopRouting.VIEWS.PHOTOS, text: "Owlstagram" }
		]

		var activeView = this.props.locationState.activeView;

		var toggleDisplay = (
			<DisplayToggleControl options={ toggleOptions }
				onChange={ this.switchActiveView } className={$wr.hasBackgroundEquipped(this.props.filteredPerks) ? "withBackground" : ""}
				activeOptionKey={ activeView } />	
		);


		if (this.props.user.perks.houses) {
			var imagePath = require("perks/houses/" + this.props.user.perks.houses.toLowerCase().replace(/ /g, "-").replace("'","") + ".png");
			var constraints = { width: "30px", cursor: "pointer" }
			var ownsHouse = true
			
			var houseAvatar = <div className="houseAvatar" >
				<img src={ imagePath } 
				data-tip = { "See inside home" } 
				onClick={ this.openHouse } 
				style={ constraints } />
			</div>
		} else {
			// student doesn't own a house yet
			var ownsHouse = false
		}

		if (activeView == OwlShopRouting.VIEWS.SHOP) {
			var patcherDisplay = ""
			if($wr.hasBackgroundEquipped(this.props.filteredPerks)) {
				patcherDisplay = ' backgroundPatcher' 
				$(".displayToggleControl").addClass('withBackground')
			} 

			var contentDisplay = (
				<div>
					<div className="row">
						<div className="col-sm-4">
							<div className="preview" ref="preview">
								<div className="previewOwl">{this.renderOwlvatar()}</div>
								<br />
								<div className="leftControls">
								<div className="nameDisplay">{nameDisplay}</div>

									<div className="detailsGroup">
									<CoinDisplay coins={this.props.user.coins} height={30} />
									<img
										src={Tiers.getIcon(this.props.user.tier)}
										className="currentTierImage"
										data-tip={tierIconTooltipText}
									/>
									{houseAvatar}
									</div>		
									{saveButton}
									{this.renderTierRequirements()}
									<ReactTooltip effect="solid" />
								</div>
							</div>
						</div>
						<div className={"patcher col-sm-8" + patcherDisplay}>
							<OwlShopPatcher
								mode="owl_shop"
								equippedPatches={this.state.equippedPatches}
								colors={this.state.colors}
								previewItemName={this.state.previewItemName}
								activePatchType={this.state.activePatchType}
								activeOtherType={this.state.activeOtherType}
								hideOwls={shouldHideOwls}
								setEquippedPatches={this.setEquippedPatches}
								setColors={this.setColors}
								setPreviewItem={this.setPreviewItem}
								setActiveType={this.setActiveType}
								updateCurrentUser={this.props.updateCurrentUser}
								fetchPerks={this.props.fetchPerks}
								fetchPatches={this.props.fetchPatches}
								beginAtTier={this.state.beginAtTier}
								previewAnimation={this.previewAnimation}
							/>
						</div>
					</div>
					<Prompt message={this.routerWillLeave} />
					<HouseModal
						ref="houseModal"
						student={this.props.user}
						activeRoom={this.state.activeRoom}
						allFurnitures={this.props.allFurnitures}
						previewItemName={this.state.previewFurnitureName}
						previewItemType={this.state.previewFurnitureType}
						ownsHouse={ownsHouse}
					/>

					<AnimationModal
						ref = "animationModal"
						student = {this.props.user}
						previewAnimation ={this.state.previewAnimationName}
					/>
				</div>
			)
		} else {
			var contentDisplay = (
				<div className="photosContainer">
					<OwlPhotosDisplay  />
				</div>
			)
		}

		var houseModal = (
			<HouseModal
			ref="houseModal"
			student={this.props.user}
			activeRoom={this.state.activeRoom}
			allFurnitures={this.props.allFurnitures}
			previewItemName={this.state.previewFurnitureName}
			previewItemType={this.state.previewFurnitureType}
			ownsHouse={ownsHouse} />
		)

		var animationModal = (
			<AnimationModal
			ref = "animationModal"
			student = {this.props.user}
			previewAnimation = {this.state.previewAnimationName}	/>
		)

		return (
			<div className="container" id="owlShopPage">
				<header className="pageHeader">
					<h1>{headerText}</h1>
				</header>
				{ toggleDisplay }
				{ contentDisplay }
				{ houseModal }
				{ animationModal }
			</div>
		);
	}

	componentDidMount() {
		// Note that Chrome (and Firefox?) won't show the custom message
		window.onbeforeunload = this.routerWillLeave;
		$(window).on("scroll", this.onScroll);
		
		// displays background if in the owl shop
		if (this.props.locationState.activeView == "shop") {
			$wr.displayBackground(this.props.user.perks.backgrounds)
		}
		if ($wr.hasBackgroundEquipped(this.props.filteredPerks)){
			$(".displayToggleControl").removeClass('withBackground')
		}

		if($wr.getURLParameterByName("openTrophyRoom")){
			this.openTrophyRoom()
		
		// for previewing furniture
		} else if($wr.getURLParameterByName("furniture")) {
			this.toggleRoom("furniture")
		}
	}

	componentWillUnmount() {
		window.onbeforeunload = null;
	}
	routerWillLeave() {
		if (this.requiresSave()) {
			return "You haven't saved changes to your owlvatar. Are you sure you want to leave?";
		}
	}
}

var BACKGROUNDS = "backgrounds";
var TITLES = "titles";
var GREETINGS = "greetings";

module.exports = OwlShopPage;



// WEBPACK FOOTER //
// ./modules/components/avatars/OwlShopPage.js